function assertBarometerListener(listener) {
  if (typeof listener !== "function") {
    throw new Error("Barometer.addListener: listener must be a function");
  }
}
function assertUpdateInterval(intervalMs) {
  if (typeof intervalMs !== "number" || !Number.isFinite(intervalMs) || intervalMs < 0) {
    throw new Error("Barometer.setUpdateInterval: interval must be a finite number at least 0");
  }
}
export {
  assertBarometerListener,
  assertUpdateInterval
};
//# sourceMappingURL=validate.js.map
